module.exports = __webpack_public_path__ + "img/order-step3-c.c017728b.png";